import { SORT_DIRECTIONS } from '../../../constants';

// TODO: change icon to appropriate one once it's added to PRISM
export const getSortGlyph = (sortDirection) =>  sortDirection
    && `arrow-${sortDirection === SORT_DIRECTIONS.ASC ? 'up' : 'down'}`;